<template>
  <form class="mt-2" id="form-modal">
    <!-- description input -->
    <div class="form-group">
      <label class="label-form">Are You Sure You Want To Delete this User</label>
    </div>
    <div class="form-group">
      <label class="label-form">Password</label>
      <input class="form-control password" name="password" v-model="password"
        placeholder="Enter Your Password To Delete " type="password" id="password" required />
    </div>

    <!-- buttons -->
    <div class="form-footer text-right">
      <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal">
        Close
      </button>
      <button type="button" :style= "[isMiniLoading ? { 'cursor' : 'default' } : { 'cursor' : 'pointer' }]" :disabled="isMiniLoading" class="btn btn-danger text-light btn-sm ml-1" @click="save">
        <font-awesome-icon v-if="isMiniLoading" icon="spinner" style="animation: spin 2s linear infinite; float:right; margin-left: 5px; margin-top: 3px;" />
        Delete
      </button>
    </div>
  </form>
</template>  

<script>
  import axios from "axios";

  export default {
    props: ["action", "formData"],
    data: function () {
      return {
        isMiniLoading:false,
        password: this.formData.password,
        role: "",
      };
    },
    created: function () {
      this.role = localStorage.getItem("role");
    },
    methods: {
      save() {
        this.isMiniLoading = true;
        let user_id = this.formData.user;
        //let page_no = this.formData.pageNumber;
        let self = this;
        let password = self.password;
  const permission = {
      headers: {
        'X-Permission': 'admin_users_delete' 
      }
    };
        axios
          .post("/admin/users/delete_user", {
            password: password,
            id: user_id,
            role: this.role,
          },permission)
          .then((response) => {
            if (response.data) {
              this.isMiniLoading = false;
              this.$toast.success("User Deleted Successfully");
              window.$("#modal").modal("hide");
              this.$store.dispatch("users/getadminusersBySearch", [
                "",
                this.formData.selectedType,
              ]);
            } else {
              this.isMiniLoading = false;
              this.$toast.error("You have Entered Wrong Password");
            }
          })
          .catch((error) => {
            this.isMiniLoading = false;
            this.$toast.error(error);
          });
      },
    },
  };
</script>